document.addEventListener('DOMContentLoaded', function () {
  const shareButtons = document.querySelectorAll('.share-button');
  
  shareButtons.forEach(button => {
    const details = button.querySelector('details');
    const copyButton = button.querySelector('.share-button__copy');
    const closeButton = button.querySelector('.share-button__close');
    const modal = button.querySelector('.share-button__fallback');
    
    // Function to toggle the modal
    function toggleModal(open) {
      if (open) {
        details.open = true;
        modal.classList.remove('hidden');
      } else {
        details.open = false;
        modal.classList.add('hidden');
      }
    }

    // Open the modal when the summary button is clicked
    details.querySelector('summary').addEventListener('click', function (e) {
      e.preventDefault();
      toggleModal(true);
    });

    // Close the modal when the copy button is clicked
    copyButton.addEventListener('click', function (e) {
      e.preventDefault();
      const input = button.querySelector('.field__input');
      input.select();
      document.execCommand('copy');
    });

    // Close the modal when the close button is clicked
    closeButton.addEventListener('click', function (e) {
      e.preventDefault();
      toggleModal(false);
    });

    // Hide modal if clicked outside of it
    window.addEventListener('click', function (event) {
      if (!details.contains(event.target) && details.open) {
        toggleModal(false);
      }
    });
  });
});
